/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRouteMatch } from 'react-router-dom';

import * as graphql from '@treams/treams-network';
import { SidebarLayout } from '@treams/treams-ui';

import Competencies from './Competencies';
import { CompetenciesSidebar } from './CompetenciesSidebar';
import {
	isOwnedJobTitle,
	skillsAnalysisFromJobTitle,
	skillsAnalysisFromUser,
} from './SkillsAnalysis';

function UserCatalogCompetencies(props: { jobTitleID: string; userID: string }) {
	const query = graphql.useJobTitleCompetenciesQuery({
		variables: { id: props.jobTitleID, userID: props.userID },
	});

	if (!query.data) {
		return <Competencies.Skeleton />;
	}

	return <Competencies skillsAnalysis={skillsAnalysisFromJobTitle(query.data.jobTitle as any)} />;
}

function UserCompetenciesSidebar(props: { userID: string }) {
	const query = graphql.useUserCompetenciesQuery({ variables: { id: props.userID } });

	if (!query.data) {
		return <CompetenciesSidebar.Skeleton />;
	}

	return <CompetenciesSidebar user={query.data.user as any} />;
}

function UserCompetenciesFactory(props: { userID: string; jobTitleID: string }) {
	const query = graphql.useUserCompetenciesQuery({ variables: { id: props.userID } });

	if (!query.data) {
		return <Competencies.Skeleton />;
	}

	return isOwnedJobTitle(query.data.user as any, props.jobTitleID) ? (
		<Competencies
			owned
			skillsAnalysis={skillsAnalysisFromUser(query.data.user as any, props.jobTitleID)}
		/>
	) : (
		<UserCatalogCompetencies jobTitleID={props.jobTitleID} userID={query.data.user.id} />
	);
}

export default function UserCompetencies() {
	const { params } = useRouteMatch<{ id: string; jobTitleID: string }>();

	return (
		<SidebarLayout sidebar={<UserCompetenciesSidebar userID={params.id} />}>
			<UserCompetenciesFactory userID={params.id} jobTitleID={params.jobTitleID} />
		</SidebarLayout>
	);
}
